import { responsiveFont } from './responsiveFont';
/**
 * Get responsive CSS for the `code` font style.
 * @beta Should not be used in production, as this might change.
 */
export function responsiveCodeFontStyle(props) {
    return responsiveFont('code', props);
}
//# sourceMappingURL=codeFontStyle.js.map